import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Sparkles } from 'lucide-react';
import { PageTransition } from '../components/PageTransition';
export function BookstorePage() {
  return <PageTransition data-id="element-238" data-mp="beuu3xqzv2yw">
      <div className="pt-24 pb-16 min-h-screen" data-id="element-239" data-mp="bfe6kyxvkz5j">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-240" data-mp="gdfld7o9qcb7">
          <div className="text-center mb-16" data-id="element-241" data-mp="gdxnum1ixmrk">
            <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-242" data-mp="1439y7p8l80vg">
              Bookstore
            </h1>
            <p className="text-xl text-white/80 max-w-2xl mx-auto mb-4" data-id="element-243" data-mp="19121tgilhbfh">
              Resources for Your Faith Journey
            </p>
            <p className="text-gold-500 text-sm font-medium uppercase tracking-wider" data-id="element-244" data-mp="u6x5atkv9r1r">
              All proceeds support 3 Doves Podcast & Outreach
            </p>
          </div>

          {/* Coming Soon Graphic */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="max-w-3xl mx-auto" data-id="element-245" data-mp="3ju4tuz7evw3i">
            <div className="relative bg-dark-800 rounded-2xl border border-dark-600 overflow-hidden" data-id="element-246" data-mp="1rnaydcy658nk">
              {/* Decorative background glow */}
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gold-500/5 via-transparent to-transparent" data-id="element-247" data-mp="1mn54rr8c9c2u"></div>

              <div className="relative px-8 py-20 md:py-28 flex flex-col items-center text-center" data-id="element-248" data-mp="1wnfgf7eq6bfw">
                {/* Animated book icons */}
                <div className="flex items-end justify-center gap-3 mb-10" data-id="element-249" data-mp="2ag54rihq7sg6">
                  {[0, 1, 2].map(i => <motion.div key={i} initial={{
                  opacity: 0,
                  y: 20
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  delay: 0.3 + i * 0.15,
                  duration: 0.6
                }} data-id="element-250" data-mp="2kc898v01w36a">
                      <div className={`rounded-lg border-2 border-gold-500/30 bg-dark-700 flex items-center justify-center shadow-lg ${i === 1 ? 'w-20 h-28 md:w-24 md:h-36' : 'w-16 h-24 md:w-20 md:h-30'}`} data-id="element-251" data-mp="1lyb4t8ywv82p">
                        <BookOpen className={`text-gold-500/40 ${i === 1 ? 'w-8 h-8 md:w-10 md:h-10' : 'w-6 h-6 md:w-8 md:h-8'}`} data-id="element-252" data-mp="20o8w3xs50dw4" />
                      </div>
                    </motion.div>)}
                </div>

                {/* Coming Soon text */}
                <motion.div initial={{
                opacity: 0,
                scale: 0.9
              }} animate={{
                opacity: 1,
                scale: 1
              }} transition={{
                delay: 0.7,
                duration: 0.6
              }} className="flex items-center gap-3 mb-6" data-id="element-253" data-mp="aep3sadxs7ov">
                  <Sparkles className="w-5 h-5 text-gold-500" data-id="element-254" data-mp="3p9g0zpygyg5z" />
                  <h2 className="text-3xl md:text-5xl font-serif font-bold text-white tracking-tight" data-id="element-255" data-mp="3p6uz50y68088">
                    Coming Soon
                  </h2>
                  <Sparkles className="w-5 h-5 text-gold-500" data-id="element-256" data-mp="lt8yvnvpcqzb" />
                </motion.div>

                <motion.p initial={{
                opacity: 0
              }} animate={{
                opacity: 1
              }} transition={{
                delay: 0.9,
                duration: 0.6
              }} className="text-white/60 text-lg max-w-lg leading-relaxed mb-8" data-id="element-257" data-mp="gs331h6qwnlk">
                  We're curating a collection of books that have deeply impacted
                  our guests and listeners — titles that point to truth, Christ,
                  and transformation.
                </motion.p>

                <motion.p initial={{
                opacity: 0
              }} animate={{
                opacity: 1
              }} transition={{
                delay: 1.1,
                duration: 0.6
              }} className="text-gold-500/80 text-sm font-medium italic" data-id="element-258" data-mp="f8t28xcf9r80">
                  Stay tuned — something good is on the way.
                </motion.p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </PageTransition>;
}